import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { remove } from 'lodash';
import { filesUrlRegex, TP } from '../../../constants/consts';
import { useTranslation } from '../../../src/i18n';
import UploadFileButton from '../../UploadFileButton';
import SubmitModalLayout from '../../SubmitModalLayout';
import EditFileCard from '../EditFileCard';
import AddFieldWithButton from '../AddFieldWithButton';

const useStyles = makeStyles(theme => ({
  content: {
    padding: theme.spacing(2),
  },
  uploadSection: {
    marginBottom: theme.spacing(4),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
      alignItems: 'center',
    },
  },
  inputField: {
    flex: 1,
  },
  orBlock: {
    textTransform: 'uppercase',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  errorMessage: {
    position: 'absolute',
    bottom: '-20px',
  },
}));

const AddFileModal = ({ addFiles, onClose, isOpened, title1, isLoading }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [files, setFiles] = React.useState([]);
  const [webLinkInputValue, updateWebLinkInputValue] = React.useState('');

  const submitFiles = () => {
    if (files?.length) {
      addFiles(files);
    } else {
      onClose();
    }
  };

  const removeFile = path => {
    const updatedFiles = [...files];
    remove(updatedFiles, { path });
    setFiles(updatedFiles);
  };

  const setFileSrc = url => {
    setFiles([...files, { path: url, file: { path: url, name: url, type: 'url' } }]);
    updateWebLinkInputValue('');
  };

  return (
    <SubmitModalLayout
      isOpened={isOpened}
      title1={t(title1)}
      onClose={onClose}
      submitFunc={submitFiles}
      isLoading={isLoading}
    >
      <div className={classes.content}>
        <div className={classes.uploadSection}>
          <AddFieldWithButton
            id="file-link"
            value={webLinkInputValue}
            onChange={updateWebLinkInputValue}
            onAdd={setFileSrc}
            placeholder={`${TP}.FN_ADD_BOOKLET_LINK`}
            label={`${TP}.FN_ADD_BOOKLET_LINK_TITLE`}
            className={classes.inputField}
            validateRegex={filesUrlRegex}
          />
          <div className={classes.orBlock}>{t(`${TP}.FN_OR`)}</div>
          <UploadFileButton
            onFilesAdd={fls => setFiles([...files, ...fls])}
            accept=".pdf, text/*"
            buttonProps={{ color: 'secondary', variant: 'outlined' }}
            uploadButtonText={`${TP}.FN_UPLOAD`}
            multiple
          />
        </div>
        {files.map(f => (
          <EditFileCard
            onDelete={() => removeFile(f?.file?.path)}
            file={{ name: f?.file?.name, size: f?.file?.size, type: f?.file?.type }}
            key={f?.file?.name}
          />
        ))}
      </div>
    </SubmitModalLayout>
  );
};

AddFileModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpened: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
};

export default AddFileModal;
